import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import {
	PermissionRole,
	ResourceType,
} from '@dealstack/shared/lib/common/fineGrainedAuthorization/permissions';
import { Response } from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { ProgrammeUserWithPermissionsRes } from '@dealstack/shared/lib/generated';

export const getProgrammeUserRequest = async (
	endpoint: string,
	args: {
		userId: string;
		programmeId: string;
	}
) => {
	const { userId, programmeId } = args;
	const response = await makeRequest<{
		payload: ProgrammeUserWithPermissionsRes;
	}>({
		endpoint: formatUnicorn(endpoint, {
			userId,
			programmeId,
		}),
		method: HTTP_METHOD.GET,
	});
	return response.payload;
};

export const updateIsContactPersonRequest = async ({
	userId,
	programmeId,
	isContactPerson,
}: {
	userId: string;
	programmeId: string;
	isContactPerson: boolean;
}) => {
	const response = await makeRequest<Response<void>>({
		endpoint: formatUnicorn(API_PATHS.MIP_PROGRAMMEID_USERS_USERID_PUT, {
			programmeId,
			userId,
		}),
		method: HTTP_METHOD.PUT,
		body: JSON.stringify({ isContactPerson }),
	});
	return response;
};

export const removeProgrammeUserRequest = async ({
	userId,
	programmeId,
}: {
	userId: string;
	programmeId: string;
}) => {
	const response = await makeRequest<Response<void>>({
		endpoint: formatUnicorn(API_PATHS.MIP_PROGRAMMEID_USERS_USERID_DELETE, {
			userId,
			programmeId,
		}),
		method: HTTP_METHOD.DELETE,
	});
	return response;
};

export const addProgrammePermissionToUser = async ({
	programmeId,
	userId,
	permissionRoles,
}: {
	programmeId: string;
	userId: string;
	permissionRoles: PermissionRole[];
}) => {
	return makeRequest<void>({
		endpoint: formatUnicorn(
			API_PATHS.PERMISSIONS_RESOURCETYPE_RESOURCEID_PERMISSIONS_CREATE_POST,
			{
				resourceType: ResourceType.PROGRAMME,
				resourceId: programmeId,
			}
		),
		method: HTTP_METHOD.POST,
		body: JSON.stringify({
			userId,
			permissionRoles,
		}),
	});
};

export const removeProgrammePermissionFromUser = async ({
	programmeId,
	userId,
	permissionRoles,
}: {
	programmeId: string;
	userId: string;
	permissionRoles: PermissionRole[];
}) => {
	return makeRequest<void>({
		endpoint: formatUnicorn(
			API_PATHS.PERMISSIONS_RESOURCETYPE_RESOURCEID_PERMISSIONS_DELETE_POST,
			{
				resourceType: ResourceType.PROGRAMME,
				resourceId: programmeId,
			}
		),
		method: HTTP_METHOD.POST,
		body: JSON.stringify({
			userId,
			permissionRoles,
		}),
	});
};
